import api from './api';

export const projectService = {
  getAll: async () => {
    const response = await api.get('/projects');
    return response.data.projects;
  },

  getByCode: async (code) => {
    const response = await api.get(`/projects/${code}`);
    return response.data.project;
  },

  create: async (projectData) => {
    const response = await api.post('/projects', projectData);
    return response.data.project;
  },

  update: async (code, projectData) => {
    const response = await api.put(`/projects/${code}`, projectData);
    return response.data.project;
  },

  delete: async (code) => {
    const response = await api.delete(`/projects/${code}`);
    return response.data;
  },

  assignEmployee: async (projectCode, empId, onboardingDate, offboardingDate) => {
    const response = await api.post(`/projects/${projectCode}/assign`, {
      employee_id: empId,
      onboarding_date: onboardingDate,
      offboarding_date: offboardingDate,
    });
    return response.data;
  },

  unassignEmployee: async (projectCode, empId) => {
    const response = await api.post(`/projects/${projectCode}/unassign`, { emp_id: empId });
    return response.data;
  },

  batchUpload: async (projects) => {
    const response = await api.post('/projects/batch', { projects });
    return response.data;
  },
};
